module.exports = "https://static.wmbcdn.com/uniweb/images/63a4e865a664ad4e357a714380a15b9c.svg";